var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-class=\"[vm.type ? 'alert-' + vm.type : null]\" role=\"alert\" class=\"alert\"><button type=\"button\" ng-if=\"vm.dismissable\" ng-click=\"vm.onDismiss()\" class=\"close\"><i class=\"glyphicon glyphicon-close\">&nbsp;</i></button><ng-transclude></ng-transclude></div>");;return buf.join("");
}